// extracted by mini-css-extract-plugin
export default {"AddRemoveWatchlistPopup":"AddRemoveWatchlistPopup","ant-modal-content":"ant-modal-content","ant-modal-body":"ant-modal-body","newWatchListFormContainer":"newWatchListFormContainer","form-group":"form-group","ant-btn":"ant-btn","watchlistArrayContainer":"watchlistArrayContainer","ant-list":"ant-list","ant-list-items":"ant-list-items","ant-list-item":"ant-list-item"};
    if(module.hot) {
      // 1793340194799
      var cssReload = require("/home/vsts/work/1/s/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  